import { Icon } from '@flippingbook/web.react-kit/dist/Icon';
import { InfoBox } from '@flippingbook/web.react-kit/dist/InfoBox';
import cx from 'classnames';

import { b } from './style.css';

export function ErrorBox(props: ErrorBox.Props) {
    const { children, className: classNameProp } = props;

    return (
        <InfoBox
            className={cx(b.name, classNameProp)}
            theme="red"
            iconPosition="middle"
            icon={<Icon name="warning" />}
        >
            {children}
        </InfoBox>
    );
}

export namespace ErrorBox {
    export interface Props {
        children: React.ReactNode;
        className?: string;
    }
}
